import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import ContactModal from '../../components/ContactModal';
import ContactBannerDetail from '../../components/ContactBannerDetail';

const styles = css`
`;

function Overview({ community, plan, agents }) {
  return (
    <div className={styles}>
      <div className="DetailSection">
        <div className="ScrollTarget" id="overview" />
        <div className="DetailOverview">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="DetailOverview_headingWrapper">
                  <h2 className="DetailOverview_heading">
                    {get(plan, 'name')}
                  </h2>
                </div>
                <div className="DetailOverview_sectionWrapper">
                  {
                    get(plan, 'price') > 0 &&
                    <div className="DetailOverview_price">
                      <span>${numeral(get(plan, 'price')).format('0,0')}</span>
                    </div>
                  }
                  {
                    !get(plan, 'price') > 0 &&
                    <div className="DetailOverview_price">
                      <h5>Quote Upon Request</h5>
                    </div>
                  }
                </div>
                {
                  get(community, 'name') &&
                  <div className="DetailOverview_sectionWrapper">
                    <span className="DetailOverview_sectionItem">
                      Community: <Link name="community-detail" community={community}>{get(community, 'name')}</Link>
                    </span>
                  </div>
                }
                <ul className="DetailOverview_list">
                  {
                    get(plan, 'beds') > 0 &&
                    <li className="DetailOverview_listItem">
                      <span className="DetailOverview_listItemValue">{get(plan, 'beds')}</span>
                      <span className="DetailOverview_listItemLabel">Beds</span>
                    </li>
                  }
                  {
                    get(plan, 'bathsFull') > 0 &&
                    <li className="DetailOverview_listItem">
                      <span className="DetailOverview_listItemValue">{get(plan, 'bathsFull')}</span>
                      <span className="DetailOverview_listItemLabel">Full Baths</span>
                    </li>
                  }
                  {
                    get(plan, 'bathsHalf') > 0 &&
                    <li className="DetailOverview_listItem">
                      <span className="DetailOverview_listItemValue">{get(plan, 'bathsHalf')}</span>
                      <span className="DetailOverview_listItemLabel">Half Baths</span>
                    </li>
                  }
                  {
                    get(plan, 'sqftLow') && get(plan, 'sqftHigh') &&
                    <li className="DetailOverview_listItem">
                      <span className="DetailOverview_listItemValue">
                        {numeral(get(plan, 'sqftLow')).format('0,0')}
                        {' - '}
                        {numeral(get(plan, 'sqftHigh')).format('0,0')}
                      </span>
                      <span className="DetailOverview_listItemLabel">Sq Ft</span>
                    </li>
                  }
                  {
                    get(plan, 'sqft') > 0 && !get(plan, 'sqftLow') && !get(plan, 'sqftHigh') &&
                    <li className="DetailOverview_listItem">
                      <span className="DetailOverview_listItemValue">{numeral(get(plan, 'sqft')).format('0,0')}</span>
                      <span className="DetailOverview_listItemLabel">Sq Ft</span>
                    </li>
                  }
                  {
                    !!get(plan, 'garages') > 0 &&
                    <li className="DetailOverview_listItem">
                      <span className="DetailOverview_listItemValue">{get(plan, 'garages')}</span>
                      <span className="DetailOverview_listItemLabel">Car Garage</span>
                    </li>
                  }
                  {
                    !!get(plan, 'stories') > 0 &&
                    <li className="DetailOverview_listItem">
                      <span className="DetailOverview_listItemValue">{get(plan, 'stories')}</span>
                      {
                        get(plan, 'stories') > 1 &&
                        <span className="DetailOverview_listItemLabel">Stories</span>
                      }
                      {
                        get(plan, 'stories') <= 1 &&
                        <span className="DetailOverview_listItemLabel">Story</span>
                      }
                    </li>
                  }
                </ul>
                {
                  get(plan, 'brochure.contentUrl') &&
                  <div className="mb-1">
                    <a
                      href={get(plan, 'brochure.contentUrl')}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-block-mobile"
                    >
                      Download Brochure
                    </a>
                  </div>
                }
                <div className="d-lg-none mb-1">
                  <ContactModal>
                    <span className="btn btn-brand3 btn-block-mobile">Schedule A Showing</span>
                  </ContactModal>
                </div>
              </div>
              <div className="col-lg-6 d-none d-lg-block">
                <ContactBannerDetail agents={agents} product="plan" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Overview.propTypes = {
  plan: PropTypes.object.isRequired,
  community: PropTypes.object,
  agents: PropTypes.arrayOf(PropTypes.object),
};

Overview.defaultProps = {
  community: undefined,
  agents: [],
};

export default withData(
  {
    community: true,
    plan: true,
  },
  {
    required: {
      plan: true,
    },
  },
)(Overview);



// WEBPACK FOOTER //
// ./src/pages/PlanLibraryDetail/Overview.js